import { render, staticRenderFns } from "./actor-card.vue?vue&type=template&id=48f4c020&scoped=true&"
import script from "./actor-card.vue?vue&type=script&lang=ts&"
export * from "./actor-card.vue?vue&type=script&lang=ts&"
import style0 from "./actor-card.vue?vue&type=style&index=0&id=48f4c020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4c020",
  null
  
)

export default component.exports